import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    marker:
      'absolute top-1/2 left-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 cursor-pointer rounded-full',
    inner:
      'bg-blue-dark block size-14 overflow-hidden rounded-full border-4 border-white',
    image: 'object-cover'
  },
  variants: {
    isSelected: {
      true: {
        inner: 'border-blue-dark'
      }
    }
  }
});
